import { Box, Popover, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../../../base/icons/components/Icon";
import { IconArrowRight, IconCheck, IconLayoutSpeaker, IconLayoutTile, IconTypeFocus } from "../../../../base/icons/svg";
import { setFilmstripVisible } from "../../../../filmstrip/actions.any";
import { setTileView, setTileViewMode } from "../../../../video-layout/actions.any";
import { LAYOUTS } from "../../../../video-layout/constants";
import { getCurrentLayout } from "../../../../video-layout/functions.any";
import TileViewDetail from "./TileViewDetail";
const ViewController = ({ classes, cx }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const tileViewEnabled = useSelector((state) => getCurrentLayout(state) === LAYOUTS.TILE_VIEW);
    const { visible } = useSelector((state) => state['features/filmstrip']);
    const matches = useMediaQuery('(min-width:760px)');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        handleChangeTileView();
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const handleChangeMainView = () => {
        dispatch(setTileView(false));
        dispatch(setFilmstripVisible(true));
    };
    const handleChangeFocusView = () => {
        dispatch(setTileView(false));
        dispatch(setFilmstripVisible(false));
    };
    const handleChangeTileView = () => {
        if (!tileViewEnabled) {
            dispatch(setTileViewMode(16));
            dispatch(setTileView(true));
            dispatch(setFilmstripVisible(false));
        }
    };
    useEffect(() => {
        if (!matches && visible) {
            handleChangeFocusView();
        }
    }, [matches]);
    return (React.createElement(Box, null,
        matches ? React.createElement(Box, { className: cx(classes.itemPopoverViewController, (!tileViewEnabled && visible) ? `${classes.choosen}` : ''), onClick: handleChangeMainView },
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center' } },
                React.createElement(Box, { sx: {
                        '& svg': {
                            height: '22px',
                            width: '22px'
                        }
                    } },
                    React.createElement(Icon, { size: 24, src: IconCheck, color: (!tileViewEnabled && visible) ? 'white' : 'transparent' })),
                React.createElement(Typography, { className: classes.textItem }, t('dialog.layout.speakerView'))),
            React.createElement(Icon, { src: IconLayoutSpeaker, size: 24, className: 'icon-item-layout' })) : React.createElement(React.Fragment, null),
        React.createElement(Box, { className: cx(classes.itemPopoverViewController, (!tileViewEnabled && !visible) ? `${classes.choosen}` : ''), onClick: handleChangeFocusView },
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center' } },
                React.createElement(Box, { sx: {
                        '& svg': {
                            height: '22px',
                            width: '22px'
                        }
                    } },
                    React.createElement(Icon, { size: 24, src: IconCheck, color: (!tileViewEnabled && !visible) ? 'white' : 'transparent' })),
                React.createElement(Typography, { className: classes.textItem }, t('dialog.layout.focus'))),
            React.createElement(Icon, { src: IconTypeFocus, size: 24, className: 'icon-item-layout' })),
        React.createElement(Box, { role: "button", className: cx(classes.itemPopoverViewController, (tileViewEnabled) ? `${classes.choosen}` : ''), onClick: handleClick },
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center' } },
                React.createElement(Box, { sx: {
                        '& svg': {
                            height: '22px',
                            width: '22px'
                        }
                    } },
                    React.createElement(Icon, { size: 24, src: IconCheck, color: (tileViewEnabled) ? 'white' : 'transparent' })),
                React.createElement(Typography, { className: classes.textItem }, t('dialog.layout.tileView'))),
            React.createElement(Box, { sx: {
                    display: 'flex',
                    marginRight: '16px',
                    '& .icon-item-layout': {
                        marginRight: '0 !important',
                    },
                    '& .icon-item-layout:first-child': {
                        marginRight: '12 !important'
                    }
                } },
                React.createElement(Icon, { style: { marginRight: '12px' }, src: IconLayoutTile, size: 24, className: 'icon-item-layout' }),
                React.createElement(Icon, { src: IconArrowRight, size: 24, className: 'icon-item-layout' }))),
        React.createElement(Popover, { id: "layout-grid-popover", className: "title-view-popover", open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            } },
            React.createElement(TileViewDetail, null))));
};
export default ViewController;
